import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import PricePanel from "@/scenes.ui/price-panel";
import {Amount} from "@/model/amount";
import {GiftDto} from "@/store/gift/types";
import {GiftUtils} from "@/utils/gift-utils";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class GiftAndPrice extends Phaser.GameObjects.Container {

    constructor(scene: Scene, g: GiftDto, callback: (giftId: string) => unknown) {
        super(scene);

        this.scene = scene;
        this.x = 0;
        this.y = 0;

        const gift = SpriteUtils.addImage(this.scene, 0, 0, GiftUtils.getAtlas(g.id), g.id);

        let amount = new Amount();
        amount.mithril = g.price;
        let price = SpriteUtils.scale(new PricePanel(scene, 39 * CU.S, 68 * CU.S, amount), 0.8 / CU.S, 0.8 / CU.S);

        gift.setInteractive().on('pointerup', function() {
            callback(g.id);
        });

        this.add([gift, price]);
    }

    public setOrigin(x: number, y: number): void {
        // do nothing
    }

}
